import React, {useState, useEffect} from "react";

import loader from '../../assets/tube-spinner-dark.svg'

const STATUS_STYLES = {

    Pending: {
        text: 'Pending',
        color: 'text-yellow',
        bgColor: 'bg-yellow'
    },
    Shortlisted: {
        text: 'Shortlisted',
        color: 'text-green',
        bgColor: 'bg-green'
    },
    Rejected: {
        text: 'Rejected',
        color: 'text-red',
        bgColor: 'bg-red'
    },
    Failed: {
        text: 'Failed',
        color: 'text-red',
        bgColor: 'bg-red'
    },
    Processing: {
        text: 'Processing',
        color: 'text-gray',
        bgColor: 'bg-gray'
    }

};

const Status = (props) =>{

    const [statusStyle, setStatusStyle] = useState(STATUS_STYLES.Processing);

    useEffect(() => {

        setStatusStyle(STATUS_STYLES[props.status] || STATUS_STYLES.Processing);
        
    }, [props.status]);


    return(
        <div className={`${statusStyle.bgColor} bg-opacity-20 ${statusStyle.color} px-3 py-2 rounded-lg text-center justify-center flex items-center text-base max-w-[9rem]`}>
           {props.status === "Processing"? 
            <>
               {statusStyle.text} <img src={loader} alt="button icon" className="ml-1 w-[1.5rem]"/> 
            </>
           : statusStyle.text
           }
            
        </div>
    )
}

export default Status;